import React from 'react';
import { Checkbox } from 'carbon-components-react';
import { useFormik } from 'formik';
interface FormValues {
  isEnquiriesShareable: boolean;
}

const GISViewers: React.FC<Props> = ({
  organisation,
  updateOrgConfiguration
}) => {
  const enquiriesShareable = organisation?.is_enquiries_shareable;

  const initialValues = {
    isEnquiriesShareable: enquiriesShareable
  };

  const { values, setFieldValue } = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: () => {}
  });

  const handleCheckboxChange = (checked: boolean) => {
    setFieldValue('isEnquiriesShareable', checked);
    const data = {
      is_enquiries_shareable: checked
    };
    updateOrgConfiguration(data);
  };

  return (
    <div id="gisViewers" className="gis-viewers spacing-padding">
      <div className="sub-section-title">GIS viewers</div>
      <div className="checkbox-container">
        <Checkbox
          labelText="Allow non-authenticated access for GIS viewers"
          id="allow-unauthenticated-gis-viewer"
          onChange={(checked: boolean) => handleCheckboxChange(checked)}
          checked={values.isEnquiriesShareable}
        />
      </div>
      <div id="gisFeatureLayersAnchor"></div>
    </div>
  );
};

interface Props {
  organisation: any;
  updateOrgConfiguration: Function;
}

export default React.memo(GISViewers);
